import { withInstall as m } from "../../utils/with-install.js";
import o from "./image.vue.js";
/* empty css           */
const p = m(o);
export {
  p as ApImage
};
